(function () {
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function pageEnd() {
    var src = document.querySelector('[data-glow-end]');
    return src ? src.getAttribute('data-glow-end') : '';
  }

  function hideEnded() {
    document.querySelectorAll('[data-glow-hide-when-ended]').forEach(function (x) { x.hidden = true; });
  }

  function initCountdowns(root) {
    (root || document).querySelectorAll('[data-glow-countdown]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '');
      var wrap = el.closest('[data-glow-timer-wrap]') || el;
      var end = Date.parse(el.getAttribute('data-end') || pageEnd());
      if (isNaN(end)) { wrap.hidden = true; return; }
      var u = {};
      ['d', 'h', 'm', 's'].forEach(function (k) { u[k] = el.querySelector('[data-u="' + k + '"]'); });
      var dayEls = el.querySelectorAll('[data-days]');
      var timer = null;
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          if (timer) clearInterval(timer);
          wrap.hidden = true;
          hideEnded();
          return;
        }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400);
        var h = Math.floor((s % 86400) / 3600);
        var m = Math.floor((s % 3600) / 60);
        var sec = s % 60;
        if (u.d) {
          u.d.textContent = pad(d);
          dayEls.forEach(function (x) { x.hidden = d === 0; });
        } else {
          h += d * 24;
        }
        if (u.h) u.h.textContent = pad(h);
        if (u.m) u.m.textContent = pad(m);
        if (u.s) u.s.textContent = pad(sec);
      }
      tick();
      if (end - Date.now() > 0) timer = setInterval(tick, 1000);
    });
  }

  function moveToBody(sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.parentElement !== document.body) {
        document.querySelectorAll('body > ' + sel).forEach(function (old) { if (old !== el) old.remove(); });
        document.body.appendChild(el);
      }
    });
  }

  function initSticky() {
    moveToBody('[data-glow-float]');
    moveToBody('[data-glow-sticky]');
    var bar = document.querySelector('body > [data-glow-sticky]');
    var root = document.documentElement;
    if (!bar) { root.style.removeProperty('--glow-sticky-h'); return; }
    if (bar.hasAttribute('data-ready')) return;
    bar.setAttribute('data-ready', '');
    var visible = new Set();
    function update() {
      var on = visible.size === 0 && window.scrollY > 500;
      bar.classList.toggle('is-on', on);
      var shown = on && getComputedStyle(bar).display !== 'none';
      root.style.setProperty('--glow-sticky-h', shown ? bar.offsetHeight + 'px' : '0px');
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target); });
        update();
      });
      document.querySelectorAll('[data-glow-cta]').forEach(function (t) { io.observe(t); });
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initFlash() {
    var el = document.querySelector('[data-glow-flash]:not([data-ready])');
    if (!el) return;
    el.setAttribute('data-ready', '');
    var code = el.getAttribute('data-code');
    var minutes = parseFloat(el.getAttribute('data-minutes')) || 10;
    var preview = el.hasAttribute('data-preview');
    var start = Date.now();
    if (!preview) {
      var key = 'glowFlash:' + code;
      try {
        var saved = parseInt(localStorage.getItem(key), 10);
        if (saved) { start = saved; } else { localStorage.setItem(key, String(start)); }
      } catch (e) {
        return; // sin almacenamiento no se puede garantizar que no se reinicie: no se muestra
      }
    }
    var end = start + minutes * 60000;
    var bar = el.parentElement;
    var fallback = bar.querySelector('[data-glow-flash-fallback]');
    var tpl = bar.querySelector('template[data-glow-flash-note]');
    var slots = document.querySelectorAll('[data-glow-flash-slot]');
    if (tpl) slots.forEach(function (s) { s.innerHTML = tpl.innerHTML; });

    function setLinks(on) {
      document.querySelectorAll('a.glow-btn').forEach(function (a) {
        if (!a.hasAttribute('data-base-href')) a.setAttribute('data-base-href', a.getAttribute('href'));
        var base = a.getAttribute('data-base-href');
        if (!on || /[?&]discount=/.test(base)) { a.setAttribute('href', base); return; }
        a.setAttribute('href', base + (base.indexOf('?') > -1 ? '&' : '?') + 'discount=' + encodeURIComponent(code));
      });
    }

    var timer = null;
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        if (timer) clearInterval(timer);
        el.hidden = true;
        slots.forEach(function (s) { s.hidden = true; });
        if (fallback) fallback.hidden = false;
        setLinks(false);
        return;
      }
      var s = Math.ceil(diff / 1000);
      var mm = pad(Math.floor(s / 60)), ss = pad(s % 60);
      document.querySelectorAll('[data-flash-m]').forEach(function (x) { x.textContent = mm; });
      document.querySelectorAll('[data-flash-s]').forEach(function (x) { x.textContent = ss; });
      el.hidden = false;
      slots.forEach(function (x) { x.hidden = false; });
      if (fallback) fallback.hidden = true;
    }
    tick();
    if (end - Date.now() > 0) {
      setLinks(true);
      timer = setInterval(tick, 1000);
    }
  }

  function init(root) {
    initCountdowns(root);
    initSticky();
    initFlash();
  }

  if (window.GlowLanding) { window.GlowLanding.init(); return; }
  window.GlowLanding = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
